import ResizeDetector from "./components/ResizeDetector";
import withResizeDetector from "./hoc/withResizeDetector";
export { withResizeDetector };
export default ResizeDetector;


//////////////////
// WEBPACK FOOTER
// ./~/react-resize-detector/lib/esm/index.js
// module id = 597
// module chunks = 0 1